webpackJsonp([82680274759079],{

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/alter-ceiling.6edf0293.jpg";

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/alter.a63f149f.jpg";

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bible.e2ed6aee.jpg";

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/closeup-inside-side-church.784eb1c5.jpg";

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/offering-candles.d329627d.jpg";

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pews.504b9d4e.jpg";

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Banner = function Banner(props) {
	  return _react2.default.createElement(
	    'section',
	    { id: 'banner', className: 'major' },
	    _react2.default.createElement(
	      'div',
	      { className: 'inner' },
	      _react2.default.createElement(
	        'header',
	        { className: 'major' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Failte Cill Lasrach'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        props.bannerText !== null || props.bannerText !== undefined ? _react2.default.createElement('div', {
	          dangerouslySetInnerHTML: {
	            __html: props.bannerText.childMarkdownRemark.html
	          }
	        }) : undefined
	      )
	    )
	  );
	}; // eslint-disable-line import/no-extraneous-dependencies
	
	
	Banner.propTypes = {
	  bannerText: _propTypes2.default.object.isRequired
	};
	
	exports.default = Banner;
	module.exports = exports['default'];

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Banner = __webpack_require__(54);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _alter = __webpack_require__(91);
	
	var _alter2 = _interopRequireDefault(_alter);
	
	var _closeupInsideSideChurch = __webpack_require__(93);
	
	var _closeupInsideSideChurch2 = _interopRequireDefault(_closeupInsideSideChurch);
	
	var _pews = __webpack_require__(95);
	
	var _pews2 = _interopRequireDefault(_pews);
	
	var _bible = __webpack_require__(92);
	
	var _bible2 = _interopRequireDefault(_bible);
	
	var _alterCeiling = __webpack_require__(90);
	
	var _alterCeiling2 = _interopRequireDefault(_alterCeiling);
	
	var _offeringCandles = __webpack_require__(94);
	
	var _offeringCandles2 = _interopRequireDefault(_offeringCandles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// images
	// eslint-disable-line import/no-extraneous-dependencies
	var Sacraments = function Sacraments(props) {
	  var _props$data$contentfu = props.data.contentfulSacraments,
	      title = _props$data$contentfu.title,
	      metaDescription = _props$data$contentfu.metaDescription,
	      bannerTitle = _props$data$contentfu.bannerTitle,
	      bannerText = _props$data$contentfu.bannerText,
	      boxOneHeading = _props$data$contentfu.boxOneHeading,
	      boxOneDescription = _props$data$contentfu.boxOneDescription,
	      boxOneLink = _props$data$contentfu.boxOneLink,
	      boxTwoHeading = _props$data$contentfu.boxTwoHeading,
	      boxTwoDescription = _props$data$contentfu.boxTwoDescription,
	      boxTwoLink = _props$data$contentfu.boxTwoLink,
	      boxThreeHeading = _props$data$contentfu.boxThreeHeading,
	      boxThreeDescription = _props$data$contentfu.boxThreeDescription,
	      boxThreeLink = _props$data$contentfu.boxThreeLink,
	      boxFourHeading = _props$data$contentfu.boxFourHeading,
	      boxFourDescription = _props$data$contentfu.boxFourDescription,
	      boxFourLink = _props$data$contentfu.boxFourLink,
	      boxFiveHeading = _props$data$contentfu.boxFiveHeading,
	      boxFiveDescription = _props$data$contentfu.boxFiveDescription,
	      boxFiveLink = _props$data$contentfu.boxFiveLink,
	      boxSixHeading = _props$data$contentfu.boxSixHeading,
	      boxSixDescription = _props$data$contentfu.boxSixDescription,
	      boxSixLink = _props$data$contentfu.boxSixLink;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        title + ' | ' + props.data.site.siteMetadata.title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: metaDescription })
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'main' },
	      _react2.default.createElement(
	        'section',
	        { id: 'one', className: 'tiles' },
	        _react2.default.createElement(
	          'article',
	          { style: { backgroundImage: 'url(' + _alter2.default + ')' } },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              boxOneHeading
	            ),
	            boxOneDescription !== null || boxOneDescription !== undefined ? _react2.default.createElement('div', {
	              dangerouslySetInnerHTML: {
	                __html: boxOneDescription.childMarkdownRemark.html
	              }
	            }) : undefined
	          ),
	          _react2.default.createElement(_gatsbyLink2.default, {
	            to: '/' + boxOneLink,
	            className: 'link primary',
	            title: boxOneHeading
	          })
	        ),
	        _react2.default.createElement(
	          'article',
	          { style: { backgroundImage: 'url(' + _closeupInsideSideChurch2.default + ')' } },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              boxTwoHeading
	            ),
	            boxTwoDescription !== null || boxTwoDescription !== undefined ? _react2.default.createElement('div', {
	              dangerouslySetInnerHTML: {
	                __html: boxTwoDescription.childMarkdownRemark.html
	              }
	            }) : undefined
	          ),
	          _react2.default.createElement(_gatsbyLink2.default, {
	            to: '/' + boxTwoLink,
	            className: 'link primary',
	            title: boxTwoHeading
	          })
	        ),
	        _react2.default.createElement(
	          'article',
	          { style: { backgroundImage: 'url(' + _pews2.default + ')' } },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              boxThreeHeading
	            ),
	            boxThreeDescription !== null || boxThreeDescription !== undefined ? _react2.default.createElement('div', {
	              dangerouslySetInnerHTML: {
	                __html: boxThreeDescription.childMarkdownRemark.html
	              }
	            }) : undefined
	          ),
	          _react2.default.createElement(_gatsbyLink2.default, {
	            to: '/' + boxThreeLink,
	            className: 'link primary',
	            title: boxThreeHeading
	          })
	        ),
	        _react2.default.createElement(
	          'article',
	          { style: { backgroundImage: 'url(' + _bible2.default + ')' } },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              boxFourHeading
	            ),
	            boxFourDescription !== null || boxFourDescription !== undefined ? _react2.default.createElement('div', {
	              dangerouslySetInnerHTML: {
	                __html: boxFourDescription.childMarkdownRemark.html
	              }
	            }) : undefined
	          ),
	          _react2.default.createElement(_gatsbyLink2.default, {
	            to: '/' + boxFourLink,
	            className: 'link primary',
	            title: boxFourHeading
	          })
	        ),
	        _react2.default.createElement(
	          'article',
	          { style: { backgroundImage: 'url(' + _alterCeiling2.default + ')' } },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              boxFiveHeading
	            ),
	            boxFiveDescription !== null || boxFiveDescription !== undefined ? _react2.default.createElement('div', {
	              dangerouslySetInnerHTML: {
	                __html: boxFiveDescription.childMarkdownRemark.html
	              }
	            }) : undefined
	          ),
	          _react2.default.createElement(_gatsbyLink2.default, {
	            to: '/' + boxFiveLink,
	            className: 'link primary',
	            title: boxFiveHeading
	          })
	        ),
	        _react2.default.createElement(
	          'article',
	          { style: { backgroundImage: 'url(' + _offeringCandles2.default + ')' } },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              boxSixHeading
	            ),
	            boxSixDescription !== null || boxSixDescription !== undefined ? _react2.default.createElement('div', {
	              dangerouslySetInnerHTML: {
	                __html: boxSixDescription.childMarkdownRemark.html
	              }
	            }) : undefined
	          ),
	          _react2.default.createElement(_gatsbyLink2.default, {
	            to: '/' + boxSixLink,
	            className: 'link primary',
	            title: boxSixHeading
	          })
	        )
	      )
	    )
	  );
	}; // eslint-disable-line import/no-extraneous-dependencies
	
	// custom components
	
	
	Sacraments.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = Sacraments;
	module.exports = exports['default'];

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.sacramentsPageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Sacraments = __webpack_require__(171);
	
	var _Sacraments2 = _interopRequireDefault(_Sacraments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-extraneous-dependencies
	// eslint-disable-line import/no-extraneous-dependencies
	
	// components
	
	
	var SacramentsPage = function (_React$Component) {
	  _inherits(SacramentsPage, _React$Component);
	
	  function SacramentsPage() {
	    _classCallCheck(this, SacramentsPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SacramentsPage.prototype.render = function render() {
	    var _props$data$site$site = this.props.data.site.siteMetadata,
	        title = _props$data$site$site.title,
	        description = _props$data$site$site.description;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          title
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: description })
	      ),
	      _react2.default.createElement(_Sacraments2.default, { data: this.props.data })
	    );
	  };
	
	  return SacramentsPage;
	}(_react2.default.Component);
	
	SacramentsPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = SacramentsPage;
	var sacramentsPageQuery = exports.sacramentsPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sacraments-js-fd9d2010c7a18cd7bbee.js